export enum QuotePartExportType {
  EXTERNAL = 'external',
  LEGACY = 'legacy',
}
